import type {BuildId} from '../../../../types'
import type {MatrixBuildFilter} from '../MatrixBuild.types'
import MatrixFilter from '../MatrixFilter/MatrixFilter'
import MatrixGrid from '../MatrixGrid/MatrixGrid'

import {useGenerateMatrix} from './MatrixMain.hooks'

type MatrixMainProps = MatrixBuildFilter & {
  className?: string
  buildId: BuildId
}

function MatrixMain({
  buildId,
  stateFilter,
  parametersFilter,
  ...matrixBuildFilter
}: MatrixMainProps) {
  const {matrix, currentStatuses} = useGenerateMatrix(buildId, stateFilter, parametersFilter)
  const isShowMatrixGrid = Boolean(matrix.length)

  return (
    <>
      <MatrixFilter
        stateFilter={stateFilter}
        parametersFilter={parametersFilter}
        currentStatuses={currentStatuses}
        buildId={buildId}
        {...matrixBuildFilter}
      />
      {isShowMatrixGrid && <MatrixGrid matrix={matrix} />}
    </>
  )
}

export default MatrixMain
